import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Role } from '../model/role.model';
import { environment } from '../../../../environments/environment'; // Adjust path as needed

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private apiUrl = `${environment.SERVER_API_URL}api/roles`; // Ensures single slash

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken'); // Ensure token is stored after login
    return new HttpHeaders({
      'Authorization': `Bearer ${token || ''}`, // Fallback to empty if null
      'x-client-offset': '-330', // IST offset
      'x-tenantid': 'your-tenant-id' // Replace with actual tenant ID from backend team
    });
  }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.apiUrl, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  getRoleById(id: number): Observable<Role> {
    return this.http.get<Role>(`${this.apiUrl}/${id}`, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  createRole(role: Role): Observable<Role> {
    return this.http.post<Role>(this.apiUrl, role, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  updateRole(id: number, role: Role): Observable<Role> {
    return this.http.put<Role>(`${this.apiUrl}/${id}`, role, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { headers: this.getAuthHeaders() })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error('API Error:', error);
    if (error.status === 401) {
      console.log('Unauthorized: Check token or tenant ID');
      // Optionally redirect to login or show a message
    }
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }
}